import React, { useEffect } from "react";
import { CommonButton } from "./CommonButton";
import { CommonHeading } from "./CommonHeading";
import VideoImage from "assets/svgIcons/PaceSubSIdeNav/LiveTVIcon";
import ReportsImage from "assets/svgIcons/PaceSubSIdeNav/Reports";
import SettingsImage from "assets/svgIcons/SideNav/Settings";
import { useHookstate } from "@hookstate/core";
import { MAP_GLOBAL_STATES } from "globalStore/globalStore";
import {
  SideNavTabsWrapper,
  SubSideNavTabs,
} from "commonComponents/SideNav/subSideNav/subSideNavStyled";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

export const PaceSideNav = () => {
  const { t } = useTranslation();
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);

  useEffect(() => {
    let getSubnavName = localStorage.getItem("mapSideNavTabState");
    if (
      getSubnavName === "Current" ||
      getSubnavName === "Reports" ||
      getSubnavName === "Settings"
    ) {
      mapSideNavTabState.set(localStorage.getItem("mapSideNavTabState"));
    } else {
      mapSideNavTabState.set("Current");
      localStorage.setItem("mapSideNavTabState","Current")
    }
  }, []);

  return (
    <div>
      <CommonHeading labelText={"Pace"} />
      <SideNavTabsWrapper>
        <SubSideNavTabs>
          <Tooltip title={t("Current")} arrow>
            <span>
              <CommonButton
                labelText={"Current"}
                displayText={"Current"}
                changeSideNavData={() => {
                  localStorage.setItem("mapSideNavTabState", "Current");
                  mapSideNavTabState.set("Current");
                }}
              >
                <VideoImage
                  color={
                    mapSideNavTabState.get() === "Current"
                      ? "var(--theme-text)"
                      : "var(--text-secondary)"
                  }
                />
              </CommonButton>
            </span>
          </Tooltip>

          <Tooltip title={t("Reports")} arrow>
            <span className="display">
              <CommonButton
                labelText={"Reports"}
                displayText={"Reports"}
                changeSideNavData={() => {
                  localStorage.setItem("mapSideNavTabState", "Reports");
                  mapSideNavTabState.set("Reports");
                }}
              >
                <ReportsImage
                  color={
                    mapSideNavTabState.get() === "Reports"
                      ? "var(--theme-text)"
                      : "var(--text-secondary)"
                  }
                />
              </CommonButton>
            </span>
          </Tooltip>

          <Tooltip title={t("Settings")} arrow>
            <span className="display">
              <CommonButton
                labelText={"Settings"}
                displayText={"Settings"}
                changeSideNavData={() => {
                  localStorage.setItem("mapSideNavTabState", "Settings");
                  mapSideNavTabState.set("Settings");
                }}
              >
                <SettingsImage
                  color={
                    mapSideNavTabState.get() === "Settings"
                      ? "var(--theme-text)"
                      : "var(--text-secondary)"
                  }
                />
              </CommonButton>
            </span>
          </Tooltip>
        </SubSideNavTabs>
      </SideNavTabsWrapper>
    </div>
  );
};
